import { DOMInfo } from '@candulabs/craft';

export const getDOMPadding = (dom: HTMLElement) => {
  return {
    left: parseInt(window.getComputedStyle(dom).paddingLeft, 10),
    right: parseInt(window.getComputedStyle(dom).paddingRight, 10),
    bottom: parseInt(window.getComputedStyle(dom).paddingTop, 10),
    top: parseInt(window.getComputedStyle(dom).paddingBottom, 10),
  };
};

export const getDOMMargin = (dom: HTMLElement) => {
  return {
    left: parseInt(window.getComputedStyle(dom).marginLeft, 10),
    right: parseInt(window.getComputedStyle(dom).marginRight, 10),
    bottom: parseInt(window.getComputedStyle(dom).marginTop, 10),
    top: parseInt(window.getComputedStyle(dom).marginBottom, 10),
  };
};

export const getDOMInfo = (dom: HTMLElement): DOMInfo => {
  const { x, y, top, left, bottom, right, width, height } = dom.getBoundingClientRect() as DOMRect;
  const margin = getDOMMargin(dom);
  const padding = getDOMPadding(dom);

  return {
    x: Math.round(x),
    y: Math.round(y),
    top: Math.round(top),
    left: Math.round(left),
    bottom: Math.round(bottom),
    right: Math.round(right),
    width: Math.round(width),
    height: Math.round(height),
    outerWidth: Math.round(width + margin.left + margin.right),
    outerHeight: Math.round(height + margin.top + margin.bottom),
    margin,
    padding,
    inFlow: !!(
      dom?.parentElement && getIndicatorDirection(dom, dom.parentElement) === 'horizontal'
    ),
  };
};

export const getComputedStyle = (dom: HTMLElement) => {
  return window.getComputedStyle(dom);
};

export const getIndicatorDirection = (
  el: HTMLElement,
  parent: HTMLElement,
): 'vertical' | 'horizontal' => {
  const style: any = getComputedStyle(el);
  const parentStyle: any = getComputedStyle(parent);

  if (parent && parentStyle.display === 'flex') {
    return parentStyle['flex-direction'] === 'column' ? 'horizontal' : 'vertical';
  }

  if (parent && parentStyle.display === 'grid') {
    return 'vertical';
  }

  if (parentStyle.float !== 'none') {
    return 'vertical';
  }

  if (style.overflow && style.overflow !== 'visible') {
    return 'vertical';
  }

  switch (style.position) {
    case 'static':
    case 'relative':
      break;
    default:
      return 'vertical';
  }

  // eslint-disable-next-line default-case
  switch (el.tagName) {
    case 'TR':
    case 'TBODY':
    case 'THEAD':
    case 'TFOOT':
      return 'horizontal';
  }

  // eslint-disable-next-line default-case
  switch (style.display) {
    case 'block':
    case 'list-item':
    case 'table':
    case 'flex':
    case 'grid':
      return 'horizontal';
  }

  return 'vertical';
};
